// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactPageContainer {
  margin:auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width:60%;
  align-items: center;
  text-align: center;
  
}

.contactContentContainer {
  margin: 5vh;
  display:flex;
  justify-content: center;
  width: 100%
}`, "",{"version":3,"sources":["webpack://./src/pages/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;;AAEpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB;AACF","sourcesContent":[".contactPageContainer {\n  margin:auto;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width:60%;\n  align-items: center;\n  text-align: center;\n  \n}\n\n.contactContentContainer {\n  margin: 5vh;\n  display:flex;\n  justify-content: center;\n  width: 100%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
